const resources = [
  {
    icon: "ri-camera-line",
    title: "Passport Photos in Billings",
    items: [
      "CVS Photo — 1801 Broadwater Ave, Billings",
      "Walgreens — 3030 King Ave W, Billings",
      "UPS Store — 3775 King Ave E, Billings",
      "Costco Photo Center — 4001 Central Ave, Billings",
    ],
  },
  {
    icon: "ri-id-card-line",
    title: "Montana DMV — Billings",
    items: [
      "MVD Billings — 2300 Overland Ave, Billings",
      "Hours: Mon–Fri 8am–5pm",
      "Provides REAL ID and driver's license for photo ID",
      "Phone: (406) 657-5400",
    ],
  },
  {
    icon: "ri-flight-takeoff-line",
    title: "Billings Logan International (BIL)",
    items: [
      "1901 Terminal Circle, Billings, MT 59105",
      "Nonstop flights to Denver, Seattle, Dallas, Minneapolis",
      "Alaska, Delta, United, American service",
      "Flight info: (406) 247-8609",
    ],
  },
];

const vitalRecords = [
  {
    icon: "ri-user-heart-line",
    label: "Birth Certificates",
    desc: "Montana Department of Public Health and Human Services — Vital Records. Order online, by mail, or at the Yellowstone County office.",
    url: "https://dphhs.mt.gov/vitalrecords/",
  },
  {
    icon: "ri-heart-pulse-line",
    label: "Death Certificates",
    desc: "Certified copies available through MT Vital Records. Required for some passport applications.",
    url: "https://dphhs.mt.gov/vitalrecords/",
  },
  {
    icon: "ri-links-line",
    label: "Marriage Certificates",
    desc: "Yellowstone County Clerk and Recorder or MT Vital Records. Needed for passport name change after marriage.",
    url: "https://dphhs.mt.gov/vitalrecords/",
  },
  {
    icon: "ri-scales-3-line",
    label: "Divorce Decrees",
    desc: "Yellowstone County District Court. Contact the Clerk of Court for certified copies.",
    url: "https://courts.mt.gov/",
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Passport Resources in Billings
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Everything you need for your Billings passport application — photos, ID, and airport info.
          </p>
        </div>

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {resources.map((r, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className={`${r.icon} text-[#1A365D] text-lg`}></i>
                  </div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{r.title}</h3>
                </div>
                <ul className="space-y-2">
                  {r.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-500">
                      <i className="ri-check-line text-[#F6C344] flex-shrink-0 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
                <i className="ri-file-text-line text-white text-lg"></i>
              </div>
              <div>
                <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
                <p className="text-white font-bold text-base leading-tight mt-0.5">Birth, Death, Marriage &amp; Divorce Records — Billings</p>
              </div>
            </div>
            <div className="px-6 py-6">
              <p className="text-gray-500 text-sm leading-relaxed mb-5">If you need a certified copy of your birth certificate for a passport application, here are the official sources for Billings residents.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                {vitalRecords.map((record, i) => (
                  <a key={i} href={record.url} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3.5 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-all group">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5"><i className={`${record.icon} text-[#1A365D] text-base group-hover:text-[#F6C344] transition-colors`}></i></div>
                    <div className="flex-1 min-w-0"><p className="font-bold text-[#1A365D] text-xs leading-snug mb-1">{record.label}</p><p className="text-gray-500 text-xs leading-relaxed mb-1.5">{record.desc}</p><span className="inline-flex items-center gap-1 text-[#1A365D] font-semibold text-xs group-hover:text-[#F6C344] transition-colors"><i className="ri-external-link-line text-xs"></i>Get Records</span></div>
                  </a>
                ))}
              </div>
              <div className="bg-amber-50 border border-amber-200 rounded-md p-3">
                <p className="text-gray-600 text-xs leading-relaxed"><i className="ri-information-line text-amber-500 mr-1.5"></i><strong>Don&apos;t see your county?</strong> Visit <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">VitalChek.com</a>.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}